import React,{Component} from 'react'
import {
    BrowserRouter as Router,
    // Switch,
    // Route,
    Link,
    // useParams
  } from "react-router-dom";
// import { Link } from "react-router-dom";
// const contentful = require("contentful");
// import { documentToHtnlString } from "contentful/rich-text-html-renderer";
import Client from "../contentful";
import image from '../img/mib.jpg';
import banner from '../img/mib-banner.jpg';
import { Player } from 'video-react';
import "../../node_modules/video-react/dist/video-react.css"
// const API = "http://localhost:8000/products/products/"
// import Video from '../video/usc-mib_professor.mp4';
import qatarsvg from '../img/qatar.svg'
import logo from '../img/logo.svg'
import ussvg from '../img/us.svg'
import { Navbar,Nav,DropdownButton,NavDropdown , Dropdown , NavItem,NavLink, ButtonGroup ,Button} from 'react-bootstrap'


import * as contentful from 'contentful';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import StudentCenteredPartnership from '../components/studentcenteredpartnership';

export default class MastersInternational extends Component {
 
   
    constructor(props){
        super(props);
        this.state = {
            // isLoaded:false,
            
            banner:"",
            image:"",
            video:"",
            mibDirectEntryTable:"",
            costsAndImportantDatesTable:"",
            globalStrategyCertificateTable:"",
            globalStrategyCostsAndImportantDates:"",
            globalStrategyCertificateCostTable:"",
            mastersStartBusinessTable:"",
            mastersStartBusinessCostAndDatesTable:"",
            mibDirectEntryCostTable:""
        }
     
    }

    formatData(items) {
      let tempItems = items.map(item => {
        let id = item.sys.id;
        
        let banner = item.fields.banner?.fields?.file?.url
        // let image = item.fields.image?.fields?.file?.url
        let mibDirectEntryTable = item.fields.mibDirectEntryTable
        let mibDirectEntryCostTable = item.fields.mibDirectEntryCostTable

        let costsAndImportantDatesTable = item.fields.costsAndImportantDatesTable

        let globalStrategyCertificateTable = item.fields.globalStrategyCertificateTable
        let globalStrategyCostsAndImportantDates = item.fields.globalStrategyCostsAndImportantDates
        let globalStrategyCertificateCostTable = item.fields.globalStrategyCertificateCostTable

        let mastersStartBusinessTable = item.fields.mastersStartBusinessTable
        let mastersStartBusinessCostAndDatesTable = item.fields.mastersStartBusinessCostAndDatesTable
        let video = item.fields.video

        // console.log(email)
        this.setState({
            banner: banner,
            video:video,
            mibDirectEntryTable:mibDirectEntryTable,
            mibDirectEntryCostTable:mibDirectEntryCostTable,
            costsAndImportantDatesTable:costsAndImportantDatesTable,
            globalStrategyCertificateTable:globalStrategyCertificateTable,
            globalStrategyCostsAndImportantDates:globalStrategyCostsAndImportantDates,
            globalStrategyCertificateCostTable:globalStrategyCertificateCostTable,
            mastersStartBusinessTable:mastersStartBusinessTable,
            mastersStartBusinessCostAndDatesTable:mastersStartBusinessCostAndDatesTable
            // image: image
        })
        console.log(this.state.mibDirectEntryTable)
      });
      return tempItems;
      console.log(items)

    }
    
    componentDidMount() {
        Client.getEntries({
            content_type : "organizationStructure"
          })
          .then(response=>{
            console.log(response.items)
            // this.formatData(response.items)

            // const description = response.items[0].fields?.description
            // document.getElementById('rich-text-body').innerHTML = documentToHtmlString(description)

          })

          Client.getEntries({
            content_type : "mastersInternational"
          })
          .then(response=>{
            console.log(response.items)
            this.formatData(response.items)

            const description = response.items[0].fields?.description
            document.getElementById('rich-text-body').innerHTML = documentToHtmlString(description)

            const mibDirectEntryText = response.items[0].fields?.mibDirectEntryText
            document.getElementById('rich-text-body1').innerHTML = documentToHtmlString(mibDirectEntryText)

            const globalStrategyCertificateText = response.items[0].fields?.globalStrategyCertificateText
            document.getElementById('rich-text-body2').innerHTML = documentToHtmlString(globalStrategyCertificateText)

            const mastersStartBusinessText = response.items[0].fields?.mastersStartBusinessText
            document.getElementById('rich-text-body3').innerHTML = documentToHtmlString(mastersStartBusinessText)
            
            const exploreYourOptionsText = response.items[0].fields?.exploreYourOptionsText
            document.getElementById('rich-text-body4').innerHTML = documentToHtmlString(exploreYourOptionsText)

            const sampleCoursesText = response.items[0].fields?.sampleCoursesText
            document.getElementById('rich-text-body5').innerHTML = documentToHtmlString(sampleCoursesText)

            const entryRequirementsText = response.items[0].fields?.entryRequirementsText
            document.getElementById('rich-text-body6').innerHTML = documentToHtmlString(entryRequirementsText)

            const globalStrategyCertificateTextt = response.items[0].fields?.globalStrategyCertificateText
            document.getElementById('rich-text-body7').innerHTML = documentToHtmlString(globalStrategyCertificateTextt)
         
            const globalStrategyCertificateSampleCoursesText = response.items[0].fields?.globalStrategyCertificateSampleCoursesText
            document.getElementById('rich-text-body8').innerHTML = documentToHtmlString(globalStrategyCertificateSampleCoursesText)
         
            const globalStrategyRequirementsText = response.items[0].fields?.globalStrategyRequirementsText
            document.getElementById('rich-text-body9').innerHTML = documentToHtmlString(globalStrategyRequirementsText)
            
            const mastersStartBusinessTextt = response.items[0].fields?.mastersStartBusinessText
            document.getElementById('rich-text-body10').innerHTML = documentToHtmlString(mastersStartBusinessTextt)
          
            const mastersStartBusinessSampleCourses =  response.items[0].fields?.mastersStartBusinessSampleCourses
            document.getElementById('rich-text-body11').innerHTML = documentToHtmlString(mastersStartBusinessSampleCourses)

            const mastersStartBusinessRequirementsText = response.items[0].fields?.mastersStartBusinessRequirementsText
            document.getElementById('rich-text-body12').innerHTML = documentToHtmlString(mastersStartBusinessRequirementsText)
          })

    }
      



    render() {
      function mouseenter0() {
        
        const button = document.getElementById('dropdown-basic0')
        button.click()
      }

      function mouseleave0(){
        const button = document.getElementById('dropdown-basic0')
        button.click()
      }
      function mouseenter1() {
        
        const button = document.getElementById('dropdown-basic1')
        button.click()
      }

      function mouseleave1(){
        const button = document.getElementById('dropdown-basic1')
        button.click()
      }

      function mouseenter2() {
        
        const button = document.getElementById('dropdown-basic2')
        button.click()
      }

      function mouseleave2(){
        const button = document.getElementById('dropdown-basic2')
        button.click()
      }
      function mouseenter3() {
        
        const button = document.getElementById('dropdown-basic3')
        button.click()
      }

      function mouseleave3(){
        const button = document.getElementById('dropdown-basic3')
        button.click()
      }
      function mouseenter4() {
        
        const button = document.getElementById('dropdown-basic4')
        button.click()
      }

      function mouseleave4(){
        const button = document.getElementById('dropdown-basic4')
        button.click()
      }
        return(
            <div>

<Navbar bg="light" collapseOnSelect expand="lg" >
  <Navbar.Brand > <Link to="/" >
        <img className="logo horizontal-logo" src={logo} alt="logo"  style={{width:"150px",  marginLeft:"1rem",marginRight:"5rem"}} />
      </Link></Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="mr-auto">

      <Nav.Link >
        <Button variant="Info" style={{
          padding: "0px",
          marginTop: "0.4rem",
          marginRight: "1rem",
          marginLeft:"10px" }}>
            <Link to="/"  style={{color: "#424242"}}>
              <b> Home </b>
            </Link>
        </Button>
      </Nav.Link>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter0} onMouseLeave={mouseleave0}> 
        
       <Dropdown>
  <Dropdown.Toggle variant="bg-light" id="dropdown-basic0" >
  <Link to="/aboutus" style={{color: "#424242"}}>
             <b>About </b>
          </Link>
  </Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Item ><Link to="/presidentsbio" style={{color: "black"}}>President’s Bio</Link></Dropdown.Item>
    <Dropdown.Item ><Link to="/coreteam" style={{color: "black"}} >Core Team</Link></Dropdown.Item>
    <Dropdown.Item ><Link to="/organization_structure" style={{color: "black"}}> Organization Structure </Link></Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter1} onMouseLeave={mouseleave1}> 
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic1" >
        <Link to="/liveclassroomtechnology" style={{color: "#424242"}}>
            <b>Technology </b>
            
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/liveclassroomtechnology" style={{color: "black"}}>Live Classroom Technology</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/location" style={{color: "black"}}>Our Location</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/technology_partner" style={{color: "black"}}>Technology Partner</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter2} onMouseLeave={mouseleave2}>
         
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic2" >
        <Link to="/academics" style={{color: "#424242"}}>
           <b>Academics </b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/academics" style={{color: "black"}}>Degrees & Programs</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/admissions" style={{color: "black"}}>Admissions</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/transfers" style={{color: "black"}}>Transfers</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/students_services" style={{color: "black"}}> Student Services</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter3} onMouseLeave={mouseleave3}>
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic3" >
        <Link to="/aspirecampus" style={{color: "#424242"}}>
            <b>Aspire Campus</b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/aspirezone" style={{color: "black"}}>Aspire Zone</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/aspireacademy" style={{color: "black"}}>Aspire Academy</Link></Dropdown.Item>
        {/* <Dropdown.Item ><Link to="/students_services" style={{color: "black"}}> Student Services</Link></Dropdown.Item> */}
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter4} onMouseLeave={mouseleave4}>
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic4" >
        <Link to="/partner_universities" style={{color: "#424242"}}>
           <b> Partner Universities</b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/partner_university_suny" style={{color: "black"}}>SUNY Adirondack</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/partner_university_south_carolina" style={{color: "black"}}>University of South Carolina</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/partner_university_arkansas" style={{color: "black"}}> Arkansas State University</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <Nav.Link>
      <Button variant="Info" style={{
    padding: "0px",
    marginTop: "0.3rem",
    marginLeft:"10px"}}>
      <Link to="/contactus" style={{color: "#424242"}}>
        <b>Contact Us</b>
        </Link>
        </Button>
      </Nav.Link>


      <li class="nav-item dropdown">
        <Button variant="Info">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown3" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img src={ussvg} />
          </a>
          </Button>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown3">
            <a class="dropdown-item" href=""><img src={qatarsvg}/></a>
          </div>
          
        </li>
     
    </Nav>
   
  </Navbar.Collapse>
</Navbar>  
           
           <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
  <div class="carousel-inner carousel-slider">
    <div class="carousel-item active">	
      <img class="d-block w-100" src={this.state.banner} alt="First slide" />
      <div class="carousel-caption carousel-caption-center">
	    <h1>Masters in International Business  </h1>
	  </div>
    </div>
  </div>
</div>




<div class="container mt-5 mb-3">
  <div class="row">

    <div class="col-lg-12">
       <p class="mt-5"><div id="rich-text-body"></div> </p>
    </div>


    {/* <div class="col-lg-8">
      <p class="mt-3">The Darla Moore School of Business is ranked No 1 in the nation for international business.  Candidates on our Masters of International Business (MIB) will participate in an international immersion that will equip them with the tools needed to analyze the cultural, legal, economic and political forces that profoundly shape global business.</p>
    </div> */}
    {/* <div class="col-lg-4"> <img src={image} class="img-fluid mt-3" /> </div> */}
  </div>

<div class="row">
    <div class="col-lg-10 mib_professor">
        {/* <video width="100%" controls>
        <source src="video/usc-mib_professor.mp4" type="video/mp4" />
        
      </video> */}
       <Player
      playsInline
      autoPlay

      src={this.state.video?.fields?.file?.url}
    />
     
    </div>
</div>


<div class="row">
<div class="col-lg-12 mt-5"> <p> <strong>This flexible program has three tracks:</strong> </p></div>

<div class="col-lg-4">
  <div class="height-100 border-line p-25">
  <h4 class="font-w-600">MIB Direct Entry</h4>

      <p class="mt-4"><div id="rich-text-body1"></div> </p>
      </div>
</div>

<div class="col-lg-4">
  <div class="height-100 border-line p-25">
  <h4 class="font-w-600">Global Strategy Certificate</h4>

   <p class="mt-4"><div id="rich-text-body2"></div></p>

 </div>
</div>


<div class="col-lg-4">
  <div class="height-100 border-line p-25">
  <h4 class="font-w-600 ">Master's Start Business</h4>

  <p class="mt-4"><div id="rich-text-body3"></div></p>
    </div>
</div>

  </div>

</div>




<div class="bg-1 p-t-50 p-b-50">
<div class="container">
  <h2 class="font-w-600">Explore your options</h2> 

<div class="row mt-5">
  
<div class="col-lg-12">
 <h4 class="mb-3 font-w-600 color-2"> MIB Direct Entry</h4>
 {/* 
  <p>Study for your Master’s in International Business with direct entry to a two-year course designed to fast track your international career.</p> */}
<div class="mb-3 font-w-600 color-2" id="rich-text-body4"></div>
  <div class="table-responsive table-section">
  <table class="table">
    <tbody>
    {

Object.entries(this.state.mibDirectEntryTable).map(([item,value])=>(
       <tr>
       
<td>{item}</td>
<td>{value}</td>
    
       </tr>
    
      
    ))
      
  }
      {/* <tr bgcolor="#fff">
        <td><b>Length</b></td>
        <td>2 years</td>
      </tr>

      <tr>
        <td><b>Credits </b></td>
        <td>30 credits (transferable*)</td>
      </tr>

      <tr bgcolor="#fff">
        <td><b>Students</b></td>
        <td>Working professionals with an undergraduate business degree and/or students who have successfully completed the Global Strategy Certificate</td>
      </tr>

      <tr>
        <td><b>Courses</b></td>
        <td>10 graduate courses, including those taken during attainment of the Global Strategy Certificate</td>
      </tr>

      <tr bgcolor="#fff">
        <td><b>Goal</b></td>
        <td>Earn a Masters of International Business and gain marketable skills to fast track your international career</td>
      </tr>

      <tr>
        <td><b>Support</b></td>
        <td>Professional development</td>
      </tr>

      <tr bgcolor="#fff">
        <td><b>Result</b></td>
        <td>Transcript, Certificate of Completion</td>
      </tr> */}


    </tbody>
  </table>
</div>

<h5 class="mt-4 mb-3"> <strong>Sample courses</strong> </h5>
  
<p><div id="rich-text-body5"></div></p>

</div>

</div>


</div>


</div>





<div class="container">
  <div class="row">
    <div class="col-lg-12">
      <h5 class="mt-4 mb-3"> <strong>Costs and Important Dates </strong> </h5>

      <p><strong> MIB – Direct Entry </strong></p>
      <p><div id="costsAndImportantDatesText"></div></p>
      <div class="table-responsive table-section">
      <table class="table text-center">
        <tbody>
         <tr bgcolor="#1C4686">
            <td class="color-1" width="50%"><b>Dates</b></td>
            <td class="color-1" width="50%"><b>January 2021</b></td>
          </tr>
        {

Object.entries(this.state.costsAndImportantDatesTable).map(([item,value])=>(
  <tr>
       
  <td  width="50%">{item}</td>
  <td  width="50%">{value}</td>
      
         </tr>
))
}
          


          {/* <tr>
            <td width="50%">Application Due</td>
            <td width="50%">7th December 2020</td>
          </tr>

          <tr>
            <td width="50%">Payment Due</td>
            <td width="50%">21st December 2020</td>
          </tr>

          <tr>
            <td width="50%">Orientation Start </td>
            <td width="50%">4th January (2 days) 2021</td>
          </tr>

          <tr>
            <td width="50%">Program Start</td>
            <td width="50%">11th January 2021</td>
          </tr> */}

        </tbody>
      </table>
    </div>

      <div class="table-responsive table-section">
      <table class="table text-center">
        <tbody>
          <tr bgcolor="#1C4686">
            <td class="color-1" width="50%"><b>{this.state.mibDirectEntryCostTable.Costs}</b></td>
            <td class="color-1" width="50%"><b>{this.state.mibDirectEntryCostTable.Date} </b></td>
          </tr>

          <tr>
            <td width="50%">{this.state.mibDirectEntryCostTable.Price}</td>
            <td width="50%">{this.state.mibDirectEntryCostTable.text}</td>
          </tr>

       </tbody>
      </table>
    </div>


    <h4 class="mt-4 mb-3"><strong>Entry Requirements </strong></h4>

     
      <p><div id="rich-text-body6"></div></p>



      <h4 class="mt-5 mb-3 color-2"><strong> Global Strategy Certificate </strong></h4>

      <p><div id="rich-text-body7"></div></p>


  <div class="table-responsive table-section mt-3">
  <table class="table">
    <tbody>
    {

Object.entries(this.state.globalStrategyCertificateTable).map(([item,value])=>(
       <tr>
       
<td>{item}</td>
<td>{value}</td>
    
       </tr>
    
      
    ))
      
  }


    </tbody>
  </table>
</div>

<p>*All credits are transferable to the Master of International Business degree program. Students may apply to enroll in the MIB program following completion of the Global Strategy Certificate.</p>



      <h5 class="mt-4 mb-3"> <strong>Sample courses</strong> </h5>


      {/* <ul class="list-unstyled line-height-30">
        <li><span class="mr-2"> <i class="fa fa-caret-right"></i> </span> Global Management</li>
        <li><span class="mr-2"> <i class="fa fa-caret-right"></i> </span> Data Analytics</li>
        <li><span class="mr-2"> <i class="fa fa-caret-right"></i> </span> Comparative Corporate Governance</li>
        <li><span class="mr-2"> <i class="fa fa-caret-right"></i> </span> Elective specialization in Management or Entrepreneurship</li>
      </ul> */}
      <p><div id="rich-text-body8"></div></p>

       <h5 class="mt-4 mb-3"> <strong>Costs and Important Dates</strong> </h5>

       <p><strong>Global Strategy Certificate</strong></p>

      <div class="table-responsive table-section">
      <table class="table text-center">
        <tbody>
          <tr bgcolor="#1C4686">
            <td class="color-1" width="50%"><b>Dates</b></td>
            <td class="color-1" width="50%"><b>January 2021</b></td>
          </tr>
          {

Object.entries(this.state.globalStrategyCostsAndImportantDates).map(([item,value])=>(
  <tr>
       
  <td  width="50%">{item}</td>
  <td  width="50%">{value}</td>
      
         </tr>
))
}

          {/* <tr>
            <td width="50%">Application Due</td>
            <td width="50%">7th December 2020</td>
          </tr>

          <tr>
            <td width="50%">Payment Due</td>
            <td width="50%">21st December 2020</td>
          </tr>

          <tr>
            <td width="50%">Orientation Start </td>
            <td width="50%">4th January (2 days) 2021</td>
          </tr>

          <tr>
            <td width="50%">Program Start</td>
            <td width="50%">11th January 2021</td>
          </tr> */}

        </tbody>
      </table>
    </div>


      <div class="table-responsive table-section">
      <table class="table text-center">
        <tbody>
          <tr bgcolor="#1C4686">
        <td class="color-1" width="50%"><b>{this.state.globalStrategyCertificateCostTable.Costs}</b></td>
            <td class="color-1" width="50%"><b>{this.state.globalStrategyCertificateCostTable.Date} </b></td>
          </tr>

          <tr>
            <td width="50%">{this.state.globalStrategyCertificateCostTable.Price}</td>
            <td width="50%">{this.state.globalStrategyCertificateCostTable.text}</td>
          </tr>

       </tbody>
      </table>
    </div>



    <h4 class="mt-4 mb-3"><strong>Entry Requirements </strong></h4>

    {/* <p><strong>Global Strategy Certificate</strong></p>


      <ul class="list-unstyled line-height-30">
        <li><span class="mr-2"> <i class="fa fa-caret-right"></i> </span> Qualifying business undergraduate degree or 1-2 years work experience</li>
        <li><span class="mr-2"> <i class="fa fa-caret-right"></i> </span> 6.0 IELTS</li>
        <li><span class="mr-2"> <i class="fa fa-caret-right"></i> </span> 2.5 GPA</li>
        <li>Résumé may be required </li>
      </ul> */}
      <p><div id="rich-text-body9"></div></p>


      <h4 class="mt-4 mb-3 color-2"><strong>Master's Start Business </strong></h4>

      <p><div id="rich-text-body10"></div></p>


  <div class="table-responsive table-section mt-3">
  <table class="table">
    <tbody>
    {

Object.entries(this.state.mastersStartBusinessTable).map(([item,value])=>(
  <tr>
       
  <td >{item}</td>
  <td  >{value}</td>
      
         </tr>
))
}
      {/* <tr>
        <td><b>Location</b></td>
        <td>Live platform from UofSC campus direct to our classrooms in Qatar</td>
      </tr>

      <tr bgcolor="#fcfcfc">
        <td><b>Length</b></td>
        <td>1 Semesters</td>
      </tr>

      <tr>
        <td><b>Credits </b></td>
        <td>6 credits (transferable*)</td>
      </tr>

      <tr bgcolor="#fcfcfc">
        <td><b>Students</b></td>
        <td>Recent graduates, no professional experience required</td>
      </tr>

      <tr>
        <td><b>Courses</b></td>
        <td>2 graduate courses, with credits applicable toward a certificate or master’s degree in business or international business</td>
      </tr>

      <tr bgcolor="#fcfcfc">
        <td><b>Goal</b></td>
        <td>Apply to a master’s degree in business, certificate, or first business-related position</td>
      </tr>

      <tr>
        <td><b>Support</b></td>
        <td>Professional development and English-language/ESL tutoring</td>
      </tr>

      <tr bgcolor="#fcfcfc">
        <td><b>Result</b></td>
        <td>Transcript, Certificate of Completion</td>
      </tr> */}


    </tbody>
  </table>
</div>

<p>*All credits are transferable to the Master of International Business degree program. Students may apply to enroll in the MIB program following completion of the Global Strategy Certificate.</p>

      <h5 class="mt-4 mb-3"> <strong>Sample courses</strong> </h5>


      {/* <ul class="list-unstyled line-height-30">
        <li> <strong>Master's Start Business</strong> </li>
        <li><span class="mr-2"> <i class="fa fa-caret-right"></i> </span> Global Management</li>
        <li><span class="mr-2"> <i class="fa fa-caret-right"></i> </span> Data Analytics</li>
      </ul> */}
      <p><div id="rich-text-body11"></div></p>


      <h5 class="mt-4 mb-3"> <strong>Costs and Important Dates</strong> </h5>

       <p> <strong>Masters Start Business</strong> </p> 


      <div class="table-responsive table-section">
      <table class="table text-center">
        <tbody>
         <tr bgcolor="#1C4686">
            <td class="color-1" width="50%"><b>Dates</b></td>
            <td class="color-1" width="50%"><b>January 2021</b></td>
          </tr>
          {/* <tr bgcolor="#1C4686">
            <td class="color-1" width="50%"><b>Dates</b></td>
            <td class="color-1" width="50%"><b>January 2021</b></td>
          </tr>

          <tr>
            <td width="50%">Application Due</td>
            <td width="50%">21st December 2020</td>
          </tr>

          <tr>
            <td width="50%">Payment Due</td>
            <td width="50%">21st December 2020</td> 
          </tr> 

          <tr>
            <td width="50%">Orientation Start </td>
            <td width="50%">4th January 2021</td> 
          </tr>

          <tr>
            <td width="50%">Bootcamp</td>
            <td width="50%">Dates to be confirmed</td> 
          </tr>

          <tr>
            <td width="50%">Program Start</td>
            <td width="50%">11th January 2021</td>
          </tr> */}

{

Object.entries(this.state.mastersStartBusinessCostAndDatesTable).map(([item,value])=>(
  <tr>
       
  <td  width="50%">{item}</td>
  <td  width="50%">{value}</td>
      
         </tr>
))
}

        </tbody>
      </table>
    </div>




      <div class="table-responsive table-section">
      <table class="table text-center">
        <tbody>


          <tr bgcolor="#1C4686">
            <td class="color-1" width="50%"><b>Costs</b></td>
            <td class="color-1" width="50%"><b>QAR 40,150</b></td>
          </tr>

        </tbody>
      </table>
    </div>



<h4 class="mt-4 mb-3"> <strong>Entry Requirements </strong> </h4>

      {/* <ul class="list-unstyled line-height-30">
        <li> <strong>Master's Start Business</strong> </li>
        <li><span class="mr-2"> <i class="fa fa-caret-right"></i> </span> Qualifying undergraduate degree</li>
        <li><span class="mr-2"> <i class="fa fa-caret-right"></i> </span> 6.0 IELTS</li>
        <li><span class="mr-2"> <i class="fa fa-caret-right"></i> </span> 2.5 GPA</li>

      </ul> */}
      <div id="rich-text-body12"></div>



<h4 class="mt-4 mb-5"> <strong>Take the next step in advancing your business career  </strong> </h4>


    </div>
  </div>
</div>







      

   </div>

            
        )
    }
}